import { Component, Input } from '@angular/core';
import { Order } from '../../../../../overview/models/order';
import { DateTimeFormatPipe } from '../../pipes/date-time-format.pipe';
import { ItemsSkeletonComponent } from '../items-skeleton/items-skeleton.component';
import { EllipsisTooltipDirective } from '../../../../../../directives/ellipsis-tooltip.directive';

@Component({
  selector: 'app-items',
  standalone: true,
  templateUrl: './items.component.html',
  imports: [DateTimeFormatPipe, ItemsSkeletonComponent, EllipsisTooltipDirective],
  styleUrl: './items.component.scss'
})
export class ItemsComponent {
  @Input() order: Order | null = null;
}
